import debug from 'debug';

/**
 * Creates a debug logger. Name is prefixed with `ydistri:` to make it easier to filter.
 * When multiple names are provided, they are joined to provide a hierarchical structure.
 *
 * @example
 * ```typescript
 * const debugLog = createDebugLog('Feature', 'Component');
 * debugLog('Some message'); // Outputs: ydistri:Feature:Component Some message
 * ```
 *
 * To enable debug logging in the browser console:
 * ```javascript
 * localStorage.debug = 'ydistri:*'  // Enable all
 * localStorage.debug = 'ydistri:Feature:*'  // Enable specific feature
 * ```
 *
 * @param names one or more names to use for the logger.
 * @returns A debug logger instance
 */
export const createDebugLog = (...names: string[]): debug.Debugger => {
  return debug(`ydistri:${names.join(':')}`);
};
